import React from "react";
import { Stack, Typography } from "@mui/material";
import styles from "../../UserManagement.module.css";
import ImageAssets from "../../../../assets";
import strings from "../../../../strings/Strings";
import { OtpInput } from "../../../../components/common/otp-input/OtpInput";

const RegistrationOtpVerification = ({
  onEditEmailClick,
  otp,
  setOtp,
  resendOtp,
  setOtpTimer,
  otpTimer,
  values,
  isShowSendCodeBtn,
  handleSendCode,
  showResendBtn
}: any) => {
  return (
    <Stack
      direction={"column"}
      alignItems={"center"}
      justifyContent={"center"}
      rowGap={showResendBtn ? 1 : 0}
    // style={{marginTop : '-13rem'}}
    >
      <Stack direction={"column"} rowGap={0}>
        {/* <Typography className={styles["user-info"]}>
          {strings.enterTheCodeSentTo}
        </Typography> */}
        {/* <Stack spacing={2}>
          <Typography
            className={styles["user-info"]}
            onClick={() => onEditEmailClick()}
            style={{ textDecoration: 'none' }}
          >
            {values}
          </Typography>
          <a
            className={styles["login-link"]}
            onClick={() => onEditEmailClick()}
          >
            <img alt="edit" src={ImageAssets.ic_edit} />
            {strings.edit}
          </a>
        </Stack> */}
      </Stack>
      <OtpInput
        otp={otp}
        setOtp={setOtp}
        resendOtp={resendOtp}
        setOtpTimer={setOtpTimer}
        otpTimer={otpTimer}
        screen={showResendBtn ? '' : 'registration'}
        isShowSendCodeBtn={isShowSendCodeBtn}
        handleSendCode={handleSendCode}
      />
    </Stack>
  );
};

export default RegistrationOtpVerification;
